/* UKB4C saved-vehicle (localStorage, 30 days) + site-wide banner.
   2026-09-29: a vehicle saved before the finder fix (no fx:2) carries wrong product handles. get() - used
   by the product-page "Fits your vehicle" check and the bike-rack filter - ignores such a save; getAny()
   still returns it for the banner and for the finder, which restores it and re-saves it corrected. */
(function() {
  var KEY = 'ukb4c_vehicle_v1';
  function read() {
    try {
      var j = JSON.parse(localStorage.getItem(KEY) || 'null');
      if (!j) return null;
      if (Date.now() - (j.ts || 0) > 30 * 24 * 3600 * 1000) { localStorage.removeItem(KEY); return null; }
      return j;
    } catch (e) { return null; }
  }
  window.UKB4CVehicle = {
    get: function() { var j = read(); return j && j.fx === 2 ? j : null; },
    getAny: read,
    set: function(v) {
      v.ts = Date.now();
      try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {}
      renderBanner();
    },
    clear: function() { try { localStorage.removeItem(KEY); } catch (e) {} renderBanner(); }
  };
  function renderBanner() {
    var old = document.getElementById('ukb4c-veh-banner');
    if (old) old.remove();
    var v = window.UKB4CVehicle.getAny();
    if (!v) return;
    if (!v.img) {
      try {
        var rg = JSON.parse(localStorage.getItem('ukb4c_reg_v1') || 'null');
        if (rg && rg.imageUrl && (v.label || '').toUpperCase().indexOf((rg.make || '~').split(' ')[0]) > -1) v.img = rg.imageUrl;
      } catch (e) {}
    }
    var bar = document.createElement('div');
    bar.id = 'ukb4c-veh-banner';
    bar.setAttribute('style', 'background:#1a1a1a;color:#fff;font-size:13px;');
    bar.innerHTML = '<div style="max-width:1500px;margin:0 auto;padding:7px 25px;display:flex;align-items:center;gap:12px;flex-wrap:wrap;">' +
      (v.img ? '<img src="' + v.img + '" alt="" style="height:30px;width:auto;border-radius:5px;background:#fff;">'
             : (v.logo ? '<img src="' + v.logo + '" alt="" style="height:26px;width:auto;border-radius:5px;background:#fff;padding:3px 7px;box-sizing:content-box;">' : '')) +
      '<span style="font-weight:700;">Your vehicle:</span><span>' + v.label + '</span>' +
      '<a href="' + (({motorhome:'/pages/motorhome-products',van:'/pages/van-campervan-products',caravan:'/pages/caravan-products'})[v.type] || v.finderUrl || '/pages/van-campervan-products') + '?myvehicle=1" style="color:#FFD307;font-weight:700;text-decoration:none;">See everything that fits</a>' +
      '<span style="flex:1;"></span>' +
      '<a href="' + (({motorhome:'/pages/motorhome-products',van:'/pages/van-campervan-products',caravan:'/pages/caravan-products'})[v.type] || v.finderUrl || '#') + '?change=1" style="color:#d1d5db;text-decoration:underline;">Change</a>' +
      '<a href="#" id="ukb4c-veh-remove" style="color:#d1d5db;text-decoration:underline;">Remove</a></div>';
    var header = document.querySelector('header, .site-header, #shopify-section-header');
    if (header && header.parentNode) header.parentNode.insertBefore(bar, header.nextSibling);
    else document.body.insertBefore(bar, document.body.firstChild);
    var rm = document.getElementById('ukb4c-veh-remove');
    if (rm) rm.addEventListener('click', function(e) { e.preventDefault(); window.UKB4CVehicle.clear(); location.reload(); });
  }
  if (document.readyState !== 'loading') renderBanner();
  else document.addEventListener('DOMContentLoaded', renderBanner);
})();
